import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import './styles.css';

const el = document.getElementById('tbo-assessment-root');
if (!el) throw new Error('Missing #tbo-assessment-root mount element');

createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
